export namespace TriggerTranslations {
  export const lots = {
    lotWillExpireOnAlertText: 'lotWillExpireOnAlertText',
    lotHasExpiredOnAlertText: 'lotHasExpiredOnAlertText',
  } as const;
}
